import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";

export const RXDB_PRICE_ACKNOWLEDGEMENT_COLLECTION_NAME =
  "price-acknowledgement";

export const useRxCollectionPriceAcknowledgement =
  (): RxCollection<PriceAcknowledgement> | null =>
    useRxCollection<PriceAcknowledgement>(
      RXDB_PRICE_ACKNOWLEDGEMENT_COLLECTION_NAME,
    );

const PRICE_ACKNOWLEDGEMENT_SCHEMA_LITERAL = {
  title: "price acknowledgement schema",
  version: 1,
  description:
    "Per-user record of the last time the user reviewed the price list",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 100,
    },
    userId: {
      type: "string",
      maxLength: 100,
    },
    acknowledgedAt: {
      type: "string",
      format: "date-time",
    },
    meta: SYNCABLE_META,
  },
  required: ["id", "userId", "acknowledgedAt", "meta"],
  indexes: ["userId"],
  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(PRICE_ACKNOWLEDGEMENT_SCHEMA_LITERAL);

export type PriceAcknowledgement = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>;

export const PRICE_ACKNOWLEDGEMENT_SCHEMA: RxJsonSchema<PriceAcknowledgement> =
  PRICE_ACKNOWLEDGEMENT_SCHEMA_LITERAL;
